<template>
  <div class="w-full min-w-0 mt-2">
    <div class="flex flex-row items-center w-full max-w-full cursor-pointer transition duration-100 ease-in-out
        hover:text-[var(--color-orange)] gap-2" @click.stop="toggleQuestion">
      <p class="text-sm sm:text-base md:text-lg break-words min-w-0">{{ question.text_question?.[lang] }}</p>
      <font-awesome-icon
        v-if="question.answers.length > 0"
        :class="{ 'rotate-180': showAnswers }"
        class="transition duration-100 ease shrink-0"
        icon="fa-chevron-down"/>
    </div>
    <div :class="{ 'grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-2 sm:gap-4': showAnswers, 'hidden': !showAnswers }"
        class="py-2 px-0 sm:px-2">
      <p class="card min-h-20 sm:min-h-24 w-full text-black text-center text-sm sm:text-base py-3 px-2"
        v-for="(answer, i) in question.answers" :key="i">{{ answer }}
      </p>
    </div>
  </div>
</template>
<script>
export default {
  name: 'WorkshopQuestionComponent',
  props: {
    question: Object,
  },
  components: {},
  data() {
    return {
      showAnswers: false,
    };
  },
  computed: {
    lang() {
      return this.$i18n.locale;
    },
  },
  methods: {
    toggleQuestion() {
      if (this.question.answers.length > 0) this.showAnswers = !this.showAnswers;
    },
  },
};
</script>
<style scoped>
.card {
  background-color: var(--color-answer-card);
}
</style>
